// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,
  api_base_url: "https://st-crm-api.elmasriagroupco.com/api/",
  api_raw_base_url: "https://st-crm-api.elmasriagroupco.com/",
  base_url: "https://st-crm.elmasriagroupco.com",
  baseHREF: "/",
  firebase: {
    apiKey: "AIzaSyCrAexwe5SimwMduWE516yMdYxrgjL1VN0",
    authDomain: "masris-group.firebaseapp.com",
    projectId: "masris-group",
    storageBucket: "masris-group.appspot.com",
    messagingSenderId: "959098777096",
    appId: "1:959098777096:web:6476ae65e015497c52abbd",
    vapidKey:
      "BEZk-T6SoJhIaUitrM8wsAnzQQdJLzioMrSIKgftKSm14lr5XNNsiN9wRqnnB_5AbETldi-vSPNxWVveC9DQ99M",
  },
  statics: {
    projectName: "masria group co",
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts